var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6218 15.6086H31.4206V15.5468H17.9998V21.5115H26.4273C25.1979 24.9838 21.8941 27.4763 17.9998 27.4763C13.0588 27.4763 9.05267 23.4702 9.05267 18.5291C9.05267 13.5881 13.0588 9.58197 17.9998 9.58197C20.2806 9.58197 22.3556 10.4424 23.9356 11.8478L28.1534 7.63C25.4901 5.1479 21.9277 3.61719 17.9998 3.61719C9.76472 3.61719 3.08789 10.294 3.08789 18.5291C3.08789 26.7643 9.76472 33.4411 17.9998 33.4411C26.235 33.4411 32.9118 26.7643 32.9118 18.5291C32.9118 17.5293 32.8089 16.5533 32.6218 15.6086Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80664 11.5884L9.70597 15.1814C11.0316 11.8993 14.2422 9.58197 17.9993 9.58197C20.28 9.58197 22.355 10.4424 23.935 11.8478L28.1528 7.63C25.4895 5.1479 21.9271 3.61719 17.9993 3.61719C12.2716 3.61719 7.30439 6.85085 4.80664 11.5884Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 33.4401C21.8517 33.4401 25.3516 31.966 27.9977 29.5689L23.3825 25.6635C21.8853 26.7976 20.0243 27.4753 18 27.4753C14.1214 27.4753 10.8281 25.0022 9.5874 21.5508L4.72461 25.2974C7.19254 30.1266 12.2044 33.4401 18 33.4401Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6219 15.6088H31.4208V15.5469H18V21.5117H26.4275C25.837 23.1796 24.7641 24.6178 23.3802 25.6654L23.3825 25.6639L27.9977 29.5693C27.6712 29.8661 32.912 25.9852 32.912 18.5293C32.912 17.5294 32.8091 16.5534 32.6219 15.6088Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c243949a769296e436d40e2e9bb0af03.svg";
export { ForwardRef as ReactComponent };